import { Api } from './Api';


export function* getSubjects(){
    const jsonData = yield Api.get(`/subjects/sss`);
    return jsonData;
}